export const FORECAST_NEW_PRODUCT_STEP = {
    ENABLE: 0,
    PLAN: 1,
    PLAN_LOADER: 2,
    PLAN_RESULT: 3,
    PLAN_EDIT: 4,
    PLAN_LIST: 5,
    PLAN_PROGRESS: 6,
};
